import React, { useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { fetch, fetchLocalAgent } from "../../actions";
import { LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import formatarData from "../../Utils/formatarData";
import { formatarCpfCnpj, formatarTelefone } from "../../Utils/utils";
import culture from "../../Utils/Culture";
import { BtnPadrao } from "../../components/Buttons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { Image } from "antd";
import { useFetch } from "../../components/Hooks/Conexao";

const fontSizePadrao = "3.1mm";

function ImpressaoVenda({ id, tipo, onCancel, ...props }) {
  const componentRef = useRef();
  const [dados, listar, listando] = useFetch(() => props.fetch().post("/venda/consulta-det", { id, isLocal: true }));
  const itens = [...(dados?.produtos || []), ...(dados?.servicos || [])];

  const empresa = props.empresa;

  const dadosFmt = useMemo(() => {
    const ret = [];
    let arrayRef = [];
    [...itens].forEach((x, inx) => {
      arrayRef.push(x);

      const limitadorRef = tipo == "A4" ? 28 : 10;

      if (arrayRef.length == limitadorRef || inx == itens.length - 1) {
        ret.push(arrayRef);
        arrayRef = [];
      }
    });

    return ret;
  }, [dados]);

  useEffect(() => {
    if (!!id)
      listar();
  }, [id]);

  function ComponentToPrint() {
    const cliente = !!dados?.clienteDetalhe ? dados.clienteDetalhe : null;

    function Header({ posicao }) {

      return <div>
        <div style={{ display: "flex", marginTop: posicao > 1 ? 5 : 0 }}>
          <div style={{ border: "1px solid #ddd", borderRadius: 5, marginRight: 2, width: "75%", padding: 5, display: "flex", alignItems: "center" }}>
            {empresa.logo && <Image preview={false} src={"data:image/png;base64," + empresa.logo} style={{ maxHeight: "18mm", maxWidth: "18mm", marginRight: 10 }} />}
            <div>
              <p style={{ margin: 0, marginBottom: 2, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Empresa</b> {empresa.fantasia || empresa.razaoSocial}</p>
              <div style={{ display: "flex" }}>
                <p style={{ margin: 0, marginBottom: 2, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>CNPJ:</b> {formatarCpfCnpj(empresa.cnpj)}</p>
                {empresa.ie && <p style={{ margin: 0, marginBottom: 2, marginLeft: 5, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>IE:</b> {empresa.ie}</p>}
              </div>
              <p style={{ margin: 0, marginBottom: 2, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Endereço:</b> {empresa.endereco}</p>
              {!!empresa.telefone && <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Telefone:</b> {formatarTelefone(empresa.telefone)}</p>}
            </div>
          </div>

          <div style={{ border: "1px solid #ddd", borderRadius: 5, width: "25%", padding: 5, textAlign: "center" }}>
            <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>DOCUMENTO:</b> {dados.tipo}</p>
            <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Número:</b> {dados.numero}</p>
            <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Emissão:</b> {formatarData(dados.data).DATA}</p>
            <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>{posicao}/{dadosFmt?.length}</b></p>
          </div>
        </div>
        <h4 style={{ textAlign: "center", margin: "10px 0", fontSize: `calc(${fontSizePadrao} + 0,5mm)` }}>DOCUMENTO AUXILIAR DE VENDA - NÃO É VALIDO COMO RECIBO E COMO GARANTIA DE MERCADORIA</h4>
      </div>;
    }

    function Footer({ breakPage = true }) {
      return <div style={{ pageBreakAfter: breakPage ? "always" : "initial", marginTop: 5 }}>
        <div style={{ display: "flex" }}>
          <div style={{ border: "1px solid #ddd", borderRadius: 5, marginRight: 2, width: "50%", padding: 5 }}>
            <p style={{ margin: 0, marginBottom: 2, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Vendedor:</b> {dados?.vendedor}</p>
            <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Obs:</b> {dados.observacoes}</p>
          </div>
          <div style={{ width: "50%" }}>
            <div style={{ border: "1px solid #ddd", borderRadius: 5, padding: 5, display: "flex", justifyContent: "space-around" }}>
              <p style={{ fontSize: fontSizePadrao, fontWeight: "bold", padding: 0, margin: 0 }}><span style={{ fontSize: '2.5mm', fontStyle: 'italic' }}>Qtd</span> {culture.format(itens.reduce((a, b) => a + b.qtd, 0))}</p>
              <p style={{ fontSize: fontSizePadrao, fontWeight: "bold", padding: 0, margin: 0 }}><span style={{ fontSize: '2.5mm', fontStyle: 'italic' }}>Bruto</span> R${culture.format(itens.reduce((a, b) => a + (b.qtd * b.valorUnitario), 0))}</p>
              <p style={{ fontSize: fontSizePadrao, fontWeight: "bold", padding: 0, margin: 0 }}><span style={{ fontSize: '2.5mm', fontStyle: 'italic' }}>Desc</span> R${culture.format(itens.reduce((a, b) => a + b.desconto, 0))}</p>
              <p style={{ fontSize: fontSizePadrao, fontWeight: "bold", padding: 0, margin: 0 }}><span style={{ fontSize: '2.5mm', fontStyle: 'italic' }}>Liq</span> R${culture.format(itens.reduce((a, b) => a + b.valorTotal, 0))}</p>
            </div>
            <div style={{ border: "1px solid #ddd", borderRadius: 5, padding: 5, display: "flex", justifyContent: "space-around" }}>
              {dados.pagamentos.length ? dados.pagamentos.map(x => <p style={{ fontSize: fontSizePadrao, fontWeight: "bold", padding: 0, margin: 0 }} key={x.id}>{x.nome} R${culture.format(x.valor)}</p>)
                : <p style={{ fontSize: fontSizePadrao, fontWeight: "bold", padding: 0, margin: 0, visibility: "hidden" }}>a</p>}
            </div>
          </div>
        </div>
      </div>;
    }

    return <div ref={componentRef}>
      {dados && <div style={{ padding: 5 }}>
        <Header posicao={1} />
        {!!cliente &&
          <div style={{ border: "1px solid #ddd", borderRadius: 5, marginRight: 2, width: "100%", padding: 5 }}>
            <div style={{ display: "flex", marginBottom: 2 }}>
              <p style={{ margin: 0, marginRight: 5, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Cliente:</b> {cliente.nome}</p>
              <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>CPF/CNPJ:</b> {formatarCpfCnpj(cliente.cpfCnpj)}</p>
              {cliente.ie && <p style={{ margin: 0, marginBottom: 2, marginLeft: 5, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>IE:</b> {cliente.ie}</p>}
            </div>

            <div style={{ display: "flex" }}>
              <p style={{ margin: 0, marginRight: 5, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Endereço:</b> {cliente.endereco}</p>
              {!!cliente.telefoneCelular && <p style={{ margin: 0, marginRight: 5, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Celular:</b> {formatarTelefone(cliente.telefoneCelular)}</p>}
              {!!cliente.telefoneFixo && <p style={{ margin: 0, fontSize: fontSizePadrao }}><b style={{ fontSize: fontSizePadrao }}>Telefone:</b> {formatarTelefone(cliente.telefoneFixo)}</p>}
            </div>
          </div>}

        {dadosFmt.map((arr, inx) => <div key={inx} >
          {inx > 0 && <Header posicao={inx + 1} />}
          <div style={{ minHeight: tipo == "A4" ? ((!!cliente && inx == 0) ? "200mm" : "230mm") : ((!!cliente && inx == 0) ? "60mm" : "80mm") }}>
            <table className="tabela-padrao headerless" style={{ marginTop: 10 }}>
              <thead>
                <th style={{ textAlign: "initial", fontSize: fontSizePadrao, borderBottom: "1px solid #ddd", padding: 0, paddingLeft: "1mm" }}>Produto</th>
                <th style={{ textAlign: "right", fontSize: fontSizePadrao, borderBottom: "1px solid #ddd", padding: 0 }}>Quant</th>
                <th style={{ textAlign: "right", fontSize: fontSizePadrao, borderBottom: "1px solid #ddd", padding: 0 }}>Val un</th>
                <th style={{ textAlign: "right", fontSize: fontSizePadrao, borderBottom: "1px solid #ddd", padding: 0 }}>Val bruto</th>
                <th style={{ textAlign: "right", fontSize: fontSizePadrao, borderBottom: "1px solid #ddd", padding: 0 }}>Desc</th>
                <th style={{ textAlign: "right", fontSize: fontSizePadrao, borderBottom: "1px solid #ddd", padding: 0, paddingRight: "1mm" }}>Val liq</th>
              </thead>

              <tbody style={{ border: "1px solid #ddd" }}>
                {arr.map(x => <tr key={x.codigo} style={{ border: "1px solid #ddd" }}>
                  <td style={{ textAlign: "initial", height: "8mm", fontSize: fontSizePadrao, paddingLeft: "1mm" }}>{x.codigo} - {x.produto}</td>
                  <td style={{ textAlign: "right", height: "8mm", fontSize: fontSizePadrao }}>{culture.format(x.qtd)}</td>
                  <td style={{ textAlign: "right", height: "8mm", fontSize: fontSizePadrao, }}>{culture.format(x.valorUnitario)}</td>
                  <td style={{ textAlign: "right", height: "8mm", fontSize: fontSizePadrao, }}>{culture.format(x.qtd * x.valorUnitario)}</td>
                  <td style={{ textAlign: "right", height: "8mm", fontSize: fontSizePadrao, }}>{culture.format(x.desconto)}</td>
                  <td style={{ textAlign: "right", height: "8mm", fontSize: fontSizePadrao, paddingRight: "1mm" }}>{culture.format(x.valorTotal)}</td>
                </tr>)}
              </tbody>
            </table>
          </div>

          <Footer breakPage={dadosFmt.length != (inx - 1)} />
        </div>)}
      </div>}
    </div>;
  }

  return <ModalPadrao footer={null} visible={!!id} width={890} onCancel={onCancel}>
    <LoadingContainerPadrao loading={listando}>
      <ReactToPrint content={() => componentRef.current}>
        <PrintContextConsumer>
          {({ handlePrint }) => <div style={{ minHeight: 500 }}>
            <div style={{ textAlign: "center", marginBottom: 10 }}>
              <BtnPadrao onClick={handlePrint}>Imprimir</BtnPadrao>
            </div>
            <ComponentToPrint />
          </div >}
        </PrintContextConsumer>
      </ReactToPrint>
    </LoadingContainerPadrao>
  </ModalPadrao>;
}

const mapStateToProps = state => ({ empresa: state.auth.empresa });

export default connect(mapStateToProps, { fetch, fetchLocalAgent })(ImpressaoVenda);